<template>
  <BFormGroup
    :label="translatedText(data.name) + (data.mandatory ? ' *' : '')"
    :label-for="`email-input-${data.key}`"
    :state="validation"
  >
    <BFormInput
        :id="`email-input-${data.key}`"
        type="email"
        :placeholder="translatedText(data.name)"
        :required="data.mandatory"
        :model-value="modelValue"
        :state="validation"
        @update:model-value="$emit('update:modelValue', $event)"
    />
    <BFormInvalidFeedback :state="validation" v-if="modelValue.length > 0">
      {{ translatedText({ it: 'Inserisci un\'email valida', en: 'Type a valid e-mail', es: 'Escriba un correo válido', de: 'Geben Sie eine gültige E-Mail ein', fr: 'Saisissez un e-mail valide' }) }}
    </BFormInvalidFeedback>
  </BFormGroup>
</template>

<script setup>
import {computed} from "vue";
import {inputStatus} from "../validations";
import {translate} from "@/domain/utils/translations";

defineEmits(['update:modelValue'])

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  lang: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    required: true
  },
  isSubmitted: {
    type: Boolean,
    default: false
  }
})

const validation = computed(() =>  inputStatus(props.data.type, props.data.mandatory, props.modelValue, props.isSubmitted))

const translatedText = (field) => translate(field, props.lang)

</script>